import { useNavigate } from "react-router-dom";
import { UserRound, Settings, CreditCard, LogOut, ShieldCheck } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const PLAN = { free: "Free", starter: "Starter", plus: "Plus", unlimited: "Unlimited" };

export const planLabel = (ent) => (!ent ? "" : ent.is_admin ? "Admin" : `${PLAN[ent.base_tier] || "Free"} plan`);

export const avatarSrc = (p) => (p?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${p}` : p);

export function Avatar({ user, className = "h-8 w-8" }) {
  const initials = (user?.name || user?.email || "?").split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  return (
    <span className={`${className} rounded-full bg-sky-500/20 text-sky-100 text-xs font-medium flex items-center justify-center overflow-hidden shrink-0`} aria-hidden="true">
      {user?.picture ? <img src={avatarSrc(user.picture)} alt="" className="h-full w-full object-cover" referrerPolicy="no-referrer" /> : initials}
    </span>
  );
}

export function ProfileMenu({ user, ent, onLogout, onPick, rail }) {
  const navigate = useNavigate();
  const go = (p) => { onPick?.(); navigate(p); };
  return (
    // Not modal: a modal menu inside the phone drawer left the next page unclickable when both closed while changing page.
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button data-testid="profile-menu-btn" aria-label={`Account menu for ${user?.name || "you"}`}
          className={`flex items-center gap-2.5 rounded-lg hover:bg-white/[0.05] outline-none focus-visible:ring-2 focus-visible:ring-sky-400/70 transition-colors ${rail ? "h-10 w-10 justify-center" : "w-full px-2 py-2 text-left"}`}>
          <Avatar user={user} />
          {!rail && (
            <span className="min-w-0 flex-1">
              <span className="block text-sm text-neutral-100 truncate" data-testid="current-user-name">{user?.name}</span>
              <span className="block text-xs text-neutral-500 truncate" data-testid="current-user-plan">{planLabel(ent)}</span>
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="top" align="start" className="bg-[#161B28] border-white/10 w-56" data-testid="profile-menu">
        <div className="px-2 py-1.5 text-xs text-neutral-500 truncate">{user?.email}</div>
        <DropdownMenuItem onClick={() => go("/app/account")} data-testid="profile-account"><UserRound className="h-4 w-4 mr-2" />Account</DropdownMenuItem>
        <DropdownMenuItem onClick={() => go("/app/settings")} data-testid="profile-settings"><Settings className="h-4 w-4 mr-2" />Settings</DropdownMenuItem>
        <DropdownMenuItem onClick={() => go("/app/billing")} data-testid="profile-billing"><CreditCard className="h-4 w-4 mr-2" />Billing</DropdownMenuItem>
        {user?.staff_role && (
          <DropdownMenuItem onClick={() => go("/staff")} data-testid="profile-staff-area"><ShieldCheck className="h-4 w-4 mr-2" />Staff area</DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={onLogout} data-testid="logout-btn"><LogOut className="h-4 w-4 mr-2" />Sign out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
